import Image from 'next/image';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  imageUrl: string;
  name: string;
  className?: string;
}

export function CircleImage(props: Props) {
  const { imageUrl, name, className } = props;

  const [isError, setIsError] = useState(false);

  if (!imageUrl || isError) {
    return (
      <div
        className={twMerge(
          'w-8 h-8 rounded-full inline-flex justify-center items-center border border-primary text-primary bg-[#FFFAF4] font-medium',
          className
        )}
      >
        <span>{name?.charAt(0)}</span>
      </div>
    );
  }

  return (
    <Image
      className={twMerge('w-10 h-10 rounded-full border border-gray_200 object-cover', className)}
      src={imageUrl}
      alt={name}
      width={32}
      height={32}
      onError={() => setIsError(true)}
    />
  );
}
